import React from 'react';
import { message } from 'antd';
import { Comments } from '../../../../../../components/Comments';
import useAddComment from '../../api/mutation/useAddComment';
import useGetDocUrl from '../../hooks/useGetDocUrl';
import useDeleteComment from '../../api/mutation/useDeleteComment';
import useEditComment from '../../api/mutation/useEditComment';
import { downloadAttachment } from '../../../../../../helpers/attachments/downloadAttachment';
import { getAttachmentNameWithExtension } from '../../../../../../helpers/getAttachmentNameWithExtension';

const CommentsBlock = ({ record, className }) => {
  const { mutateAsync: addComment, isLoading: isAddLoading } = useAddComment();
  const { mutateAsync: deleteComment, isLoading: isDeleteLoading } =
    useDeleteComment();
  const { mutateAsync: editComment, isLoading: isEditLoading } =
    useEditComment();

  const getDocUrl = useGetDocUrl();

  const getAttachmentUrl = getDocUrl({ permitId: record?.id });

  const handleAddComment = async ({ text, attachments }) => {
    await addComment({
      id: record?.id,
      comment: text?.trim() || '',
      attachments,
    });
  };

  const handleEditComment = async ({
    id,
    text,
    attachments,
    removedAttachmentIds,
  }) => {
    await editComment({
      id,
      comment: text?.trim() || '',
      attachments,
      removedAttachmentIds,
    });
  };

  const handleDeleteComment = async (id) => {
    await deleteComment(id);
  };

  const handleDownloadAttachment = async (attachment) => {
    const url = await getAttachmentUrl(attachment);

    if (!url) {
      message.error('Не удалось скачать файл');
      return;
    }

    downloadAttachment({
      url,
      title: getAttachmentNameWithExtension(attachment),
    });
  };

  const isLoading = isDeleteLoading || isAddLoading || isEditLoading;

  return (
    <div className={className} style={{ maxWidth: 600 }}>
      <Comments
        comments={record?.notes || []}
        onAddComment={handleAddComment}
        onEditComment={handleEditComment}
        onDeleteComment={handleDeleteComment}
        getAttachmentUrl={getAttachmentUrl}
        onDownloadAttachment={handleDownloadAttachment}
        loading={isLoading}
      />
    </div>
  );
};

export default CommentsBlock;
